module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.visible) ? _c('div', {
    staticClass: "plano_modal"
  }, [_c('b-card', {
    staticStyle: {
      "width": "600px"
    }
  }, [_c('label', [_c('h3', [_vm._v("Edit Caddy")])]), _vm._v(" "), _c('b-container', {
    attrs: {
      "fluid": ""
    }
  }, [_c('b-row', [_c('b-col', {
    attrs: {
      "sm": "4"
    }
  }, [_c('label', [_vm._v("Fixed:")])]), _vm._v(" "), _c('b-col', {
    attrs: {
      "sm": "8"
    }
  }, [_c('b-form-checkbox', {
    model: {
      value: (_vm.fixed),
      callback: function($$v) {
        _vm.fixed = $$v
      },
      expression: "fixed"
    }
  })], 1)], 1), _vm._v(" "), _c('b-row', [_c('b-col', {
    attrs: {
      "sm": "4"
    }
  }, [_c('label', [_vm._v("Width:")])]), _vm._v(" "), _c('b-col', {
    attrs: {
      "sm": "8"
    }
  }, [_c('NumberInput', {
    model: {
      value: (_vm.width),
      callback: function($$v) {
        _vm.width = $$v
      },
      expression: "width"
    }
  })], 1)], 1), _vm._v(" "), _c('b-row', [_c('b-col', {
    attrs: {
      "sm": "4"
    }
  }, [_c('label', [_vm._v("Height:")])]), _vm._v(" "), _c('b-col', {
    attrs: {
      "sm": "8"
    }
  }, [_c('NumberInput', {
    model: {
      value: (_vm.height),
      callback: function($$v) {
        _vm.height = $$v
      },
      expression: "height"
    }
  })], 1)], 1), _vm._v(" "), _c('b-row', [_c('b-col', {
    attrs: {
      "sm": "4"
    }
  }, [_c('label', [_vm._v("Content X:")])]), _vm._v(" "), _c('b-col', {
    attrs: {
      "sm": "8"
    }
  }, [_c('NumberInput', {
    model: {
      value: (_vm.contentX),
      callback: function($$v) {
        _vm.contentX = $$v
      },
      expression: "contentX"
    }
  })], 1)], 1), _vm._v(" "), _c('b-row', [_c('b-col', {
    attrs: {
      "sm": "4"
    }
  }, [_c('label', [_vm._v("Content Y:")])]), _vm._v(" "), _c('b-col', {
    attrs: {
      "sm": "8"
    }
  }, [_c('NumberInput', {
    model: {
      value: (_vm.contentY),
      callback: function($$v) {
        _vm.contentY = $$v
      },
      expression: "contentY"
    }
  })], 1)], 1), _vm._v(" "), _c('b-row', [_c('b-col', {
    attrs: {
      "sm": "4"
    }
  }, [_c('label', [_vm._v("Content Width:")])]), _vm._v(" "), _c('b-col', {
    attrs: {
      "sm": "8"
    }
  }, [_c('NumberInput', {
    model: {
      value: (_vm.contentWidth),
      callback: function($$v) {
        _vm.contentWidth = $$v
      },
      expression: "contentWidth"
    }
  })], 1)], 1), _vm._v(" "), _c('b-row', [_c('b-col', {
    attrs: {
      "sm": "4"
    }
  }, [_c('label', [_vm._v("Content Height:")])]), _vm._v(" "), _c('b-col', {
    attrs: {
      "sm": "8"
    }
  }, [_c('NumberInput', {
    model: {
      value: (_vm.contentHeight),
      callback: function($$v) {
        _vm.contentHeight = $$v
      },
      expression: "contentHeight"
    }
  })], 1)], 1), _vm._v(" "), _c('b-row', [_c('b-col', {
    attrs: {
      "sm": "4"
    }
  }, [_c('label', [_vm._v("Cover Height:")])]), _vm._v(" "), _c('b-col', {
    attrs: {
      "sm": "8"
    }
  }, [_c('NumberInput', {
    model: {
      value: (_vm.coverHeight),
      callback: function($$v) {
        _vm.coverHeight = $$v
      },
      expression: "coverHeight"
    }
  })], 1)], 1), _vm._v(" "), _c('b-row', [_c('b-col', {
    attrs: {
      "sm": "4"
    }
  }, [_c('label', [_vm._v("Top Pawl:")])]), _vm._v(" "), _c('b-col', {
    attrs: {
      "sm": "8"
    }
  }, [_c('NumberInput', {
    model: {
      value: (_vm.topPawl),
      callback: function($$v) {
        _vm.topPawl = $$v
      },
      expression: "topPawl"
    }
  })], 1)], 1), _vm._v(" "), _c('b-row', [_c('b-col', {
    attrs: {
      "sm": "4"
    }
  }, [_c('label', [_vm._v("Label text:")])]), _vm._v(" "), _c('b-col', {
    attrs: {
      "sm": "8"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.labelText),
      expression: "labelText"
    }],
    domProps: {
      "value": (_vm.labelText)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.labelText = $event.target.value
      }
    }
  })])], 1), _vm._v(" "), _c('b-row', [_c('b-col', {
    attrs: {
      "sm": "4"
    }
  }, [_c('label', [_vm._v("Bottom Pawl:")])]), _vm._v(" "), _c('b-col', {
    attrs: {
      "sm": "8"
    }
  }, [_c('NumberInput', {
    model: {
      value: (_vm.bottomPawl),
      callback: function($$v) {
        _vm.bottomPawl = $$v
      },
      expression: "bottomPawl"
    }
  })], 1)], 1), _vm._v(" "), _c('b-row', [_c('b-col', {
    attrs: {
      "sm": "4"
    }
  }, [_c('label', [_vm._v("Pawl Interval:")])]), _vm._v(" "), _c('b-col', {
    attrs: {
      "sm": "8"
    }
  }, [_c('NumberInput', {
    model: {
      value: (_vm.pawlInterval),
      callback: function($$v) {
        _vm.pawlInterval = $$v
      },
      expression: "pawlInterval"
    }
  })], 1)], 1), _vm._v(" "), _c('b-row', [_c('b-col', {
    attrs: {
      "sm": "4"
    }
  }, [_c('label', [_vm._v("Left Adhesive:")])]), _vm._v(" "), _c('b-col', {
    attrs: {
      "sm": "8"
    }
  }, [_c('b-form-checkbox', {
    model: {
      value: (_vm.leftAdhesive),
      callback: function($$v) {
        _vm.leftAdhesive = $$v
      },
      expression: "leftAdhesive"
    }
  })], 1)], 1), _vm._v(" "), _c('b-row', [_c('b-col', {
    attrs: {
      "sm": "4"
    }
  }, [_c('label', [_vm._v("Right Adhesive:")])]), _vm._v(" "), _c('b-col', {
    attrs: {
      "sm": "8"
    }
  }, [_c('b-form-checkbox', {
    model: {
      value: (_vm.rightAdhesive),
      callback: function($$v) {
        _vm.rightAdhesive = $$v
      },
      expression: "rightAdhesive"
    }
  })], 1)], 1), _vm._v(" "), _c('b-row', [_c('b-col', {
    attrs: {
      "sm": "4"
    }
  }, [_c('label', [_vm._v("Bottom Adhesive:")])]), _vm._v(" "), _c('b-col', {
    attrs: {
      "sm": "8"
    }
  }, [_c('b-form-checkbox', {
    model: {
      value: (_vm.bottomAdhesive),
      callback: function($$v) {
        _vm.bottomAdhesive = $$v
      },
      expression: "bottomAdhesive"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('b-button-toolbar', [_c('b-button', {
    staticStyle: {
      "margin": "5px"
    },
    attrs: {
      "variant": "primary"
    },
    on: {
      "click": function($event) {
        _vm.validate();
      }
    }
  }, [_vm._v("Ok")]), _vm._v(" "), _c('b-button', {
    staticStyle: {
      "margin": "5px"
    },
    on: {
      "click": function($event) {
        _vm.cancel();
      }
    }
  }, [_vm._v("Cancel")])], 1)], 1)], 1) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-4aa0760a","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/plano/edits/edit_board_caddy.vue
// module id = 3164
// module chunks = 0